var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _vm.modulo === "booking"
        ? [
            _vm.flightdirection === "outward"
              ? _c("h2", [
                  _vm._v(
                    _vm._s(
                      _vm.tab_header_flightdetailsoutward[_vm.getCurrentLocale]
                    ) + ":"
                  ),
                ])
              : _vm._e(),
            _vm._v(" "),
            _vm.flightdirection === "return"
              ? _c("h2", [
                  _vm._v(
                    _vm._s(
                      _vm.tab_header_flightdetailsreturn[_vm.getCurrentLocale]
                    ) + ":"
                  ),
                ])
              : _vm._e(),
          ]
        : _vm._e(),
      _vm._v(" "),
      _vm.modulo === "services"
        ? [
            _vm.flightdirection === "outward"
              ? _c("h2", [
                  _vm._v(
                    _vm._s(
                      _vm.tab_header_flightdetailsoutwardservices[
                        _vm.getCurrentLocale
                      ]
                    ) + ":"
                  ),
                ])
              : _vm._e(),
            _vm._v(" "),
            _vm.flightdirection === "return"
              ? _c("h2", [
                  _vm._v(
                    _vm._s(
                      _vm.tab_header_flightdetailsreturnservices[
                        _vm.getCurrentLocale
                      ]
                    ) + ":"
                  ),
                ])
              : _vm._e(),
          ]
        : _vm._e(),
      _vm._v(" "),
      _vm.modulo === "booking"
        ? _c(
            "div",
            {
              staticClass: "intro table-wrapper full-width hidden-table-sm box",
              staticStyle: { "border-spacing": "8px" },
            },
            [
              _c("div", { staticClass: "col-md-4 table-cell sdr-box" }, [
                _c("dl", { staticClass: "term-description" }, [
                  _c("dt", [
                    _vm._v(_vm._s(_vm.airline[_vm.getCurrentLocale]) + ":"),
                  ]),
                  _c("dd", [_vm._v("Sundair")]),
                  _vm._v(" "),
                  _c("dt", [
                    _vm._v(_vm._s(_vm.flighttype[_vm.getCurrentLocale]) + ":"),
                  ]),
                  _c("dd", [_vm._v("Economy")]),
                  _vm._v(" "),
                  _c("dt", [
                    _vm._v(
                      _vm._s(_vm.cancellation[_vm.getCurrentLocale]) + ":"
                    ),
                  ]),
                  _c("dd", [
                    _vm._v(
                      _vm._s(_vm.avgpers[_vm.getCurrentLocale]) +
                        "/" +
                        _vm._s(_vm._f("rndAmntRUAFWZ")(65))
                    ),
                  ]),
                  _vm._v(" "),
                  _c("dt", [
                    _vm._v(
                      _vm._s(_vm.flightchange[_vm.getCurrentLocale]) + ":"
                    ),
                  ]),
                  _c("dd", [
                    _vm._v(
                      _vm._s(_vm.avgpers[_vm.getCurrentLocale]) +
                        "/" +
                        _vm._s(_vm._f("rndAmntRUAFWZ")(65))
                    ),
                  ]),
                ]),
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "col-md-8 table-cell" }, [
                _c(
                  "div",
                  { staticClass: "detailed-features booking-details" },
                  [
                    _c("div", { staticClass: "sdr-box" }, [
                      _vm.flightdirection === "outward"
                        ? _c(
                            "a",
                            {
                              staticClass: "button btn-mini yellow pull-right",
                              attrs: { href: "#" },
                            },
                            [
                              _vm._v(
                                "STOPS: " +
                                  _vm._s(
                                    _vm.getBookingLockfaresResults.outwardFlight
                                      .stopAirport === null
                                      ? "0"
                                      : "1"
                                  )
                              ),
                            ]
                          )
                        : _vm._e(),
                      _vm._v(" "),
                      _vm.flightdirection === "return"
                        ? _c(
                            "a",
                            {
                              staticClass: "button btn-mini yellow pull-right",
                              attrs: { href: "#" },
                            },
                            [
                              _vm._v(
                                "STOPS: " +
                                  _vm._s(
                                    _vm.getBookingLockfaresResults.outwardFlight
                                      .stopAirport === null
                                      ? "0"
                                      : "1"
                                  ) +
                                  " "
                              ),
                            ]
                          )
                        : _vm._e(),
                      _vm._v(" "),
                      _vm.flightdirection === "outward"
                        ? _c("h4", { staticClass: "box-title" }, [
                            _vm._v(
                              _vm._s(_vm.from[_vm.getCurrentLocale]) +
                                " " +
                                _vm._s(_vm.getBookingDepArprtName) +
                                " " +
                                _vm._s(_vm.to[_vm.getCurrentLocale]) +
                                "  " +
                                _vm._s(_vm.getBookingDesArprtName)
                            ),
                            _c("small", [
                              _vm._v(
                                _vm._s(_vm.outwardflight[_vm.getCurrentLocale])
                              ),
                            ]),
                          ])
                        : _vm._e(),
                      _vm._v(" "),
                      _vm.flightdirection === "return" &&
                      _vm.getBookingDepArprtNameReturnToOther === null
                        ? _c("h4", { staticClass: "box-title" }, [
                            _vm._v(
                              _vm._s(_vm.from[_vm.getCurrentLocale]) +
                                " " +
                                _vm._s(_vm.getBookingDesArprtName) +
                                " " +
                                _vm._s(_vm.to[_vm.getCurrentLocale]) +
                                "  " +
                                _vm._s(_vm.getBookingDepArprtName)
                            ),
                            _c("small", [
                              _vm._v(
                                _vm._s(_vm.returnflight[_vm.getCurrentLocale])
                              ),
                            ]),
                          ])
                        : _vm._e(),
                      _vm._v(" "),
                      _vm.flightdirection === "return" &&
                      _vm.getBookingDepArprtNameReturnToOther !== null
                        ? _c("h4", { staticClass: "box-title" }, [
                            _vm._v(
                              _vm._s(_vm.from[_vm.getCurrentLocale]) +
                                " " +
                                _vm._s(
                                  _vm.getBookingDepArprtNameReturnToOther
                                ) +
                                " " +
                                _vm._s(_vm.to[_vm.getCurrentLocale]) +
                                "  " +
                                _vm._s(_vm.getBookingDesArprtNameReturnToOther)
                            ),
                            _c("small", [
                              _vm._v(
                                _vm._s(_vm.returnflight[_vm.getCurrentLocale])
                              ),
                            ]),
                          ])
                        : _vm._e(),
                    ]),
                    _vm._v(" "),
                    _c("div", { staticClass: "table-wrapper flights" }, [
                      _c("div", { staticClass: "table-row first-flight" }, [
                        _c("div", { staticClass: "table-cell logo" }, [
                          _c("img", {
                            staticStyle: { "padding-bottom": "3px" },
                            attrs: {
                              src: "/res/images/sdr140x30.png",
                              alt: "",
                            },
                          }),
                          _vm._v(" "),
                          _vm.flightdirection === "outward"
                            ? _c("label", [
                                _vm._v(
                                  _vm._s(
                                    _vm.getBookingLockfaresResults.outwardFlight
                                      .flightNo
                                  )
                                ),
                              ])
                            : _vm._e(),
                          _vm._v(" "),
                          _vm.flightdirection === "return"
                            ? _c("label", [
                                _vm._v(
                                  _vm._s(
                                    _vm.getBookingLockfaresResults.inboundFlight
                                      .flightNo
                                  )
                                ),
                              ])
                            : _vm._e(),
                        ]),
                        _vm._v(" "),
                        _c("div", { staticClass: "table-cell timing-detail" }, [
                          _c("div", { staticClass: "timing" }, [
                            _c("div", { staticClass: "check-in" }, [
                              _c("label", [
                                _vm._v(
                                  _vm._s(_vm.takeoff[_vm.getCurrentLocale])
                                ),
                              ]),
                              _vm._v(" "),
                              _vm.flightdirection === "outward"
                                ? _c("span", [
                                    _vm._v(
                                      _vm._s(
                                        _vm._f("dateFlightCart")(
                                          _vm.getBookingCart[0].outward.depDT
                                        )
                                      ) +
                                        ", " +
                                        _vm._s(
                                          _vm._f("momentTime")(
                                            _vm.getBookingCart[0].outward.depDT
                                          )
                                        )
                                    ),
                                  ])
                                : _vm._e(),
                              _vm._v(" "),
                              _vm.flightdirection === "return"
                                ? _c("span", [
                                    _vm._v(
                                      _vm._s(
                                        _vm._f("dateFlightCart")(
                                          _vm.getBookingCart[0].return.depDT
                                        )
                                      ) +
                                        ", " +
                                        _vm._s(
                                          _vm._f("momentTime")(
                                            _vm.getBookingCart[0].return.depDT
                                          )
                                        )
                                    ),
                                  ])
                                : _vm._e(),
                            ]),
                            _vm._v(" "),
                            _c("div", { staticClass: "duration text-center" }, [
                              _c("i", { staticClass: "soap-icon-clock" }),
                              _vm._v(" "),
                              _vm.flightdirection === "outward"
                                ? _c("span", [
                                    _vm._v(
                                      _vm._s(
                                        _vm._f("durationFlightCart")(
                                          _vm.getBookingCart[0].outward.dur
                                        )
                                      )
                                    ),
                                  ])
                                : _vm._e(),
                              _vm._v(" "),
                              _vm.flightdirection === "return"
                                ? _c("span", [
                                    _vm._v(
                                      _vm._s(
                                        _vm._f("durationFlightCart")(
                                          _vm.getBookingCart[0].return.dur
                                        )
                                      )
                                    ),
                                  ])
                                : _vm._e(),
                            ]),
                            _vm._v(" "),
                            _c("div", { staticClass: "check-out" }, [
                              _c("label", [
                                _vm._v(
                                  _vm._s(_vm.landing[_vm.getCurrentLocale])
                                ),
                              ]),
                              _vm._v(" "),
                              _vm.flightdirection === "outward"
                                ? _c("span", [
                                    _vm._v(
                                      _vm._s(
                                        _vm._f("dateFlightCart")(
                                          _vm.getBookingCart[0].outward.desDT
                                        )
                                      ) +
                                        ", " +
                                        _vm._s(
                                          _vm._f("momentTime")(
                                            _vm.getBookingCart[0].outward.desDT
                                          )
                                        )
                                    ),
                                  ])
                                : _vm._e(),
                              _vm._v(" "),
                              _vm.flightdirection === "return"
                                ? _c("span", [
                                    _vm._v(
                                      _vm._s(
                                        _vm._f("dateFlightCart")(
                                          _vm.getBookingCart[0].return.desDT
                                        )
                                      ) +
                                        ", " +
                                        _vm._s(
                                          _vm._f("momentTime")(
                                            _vm.getBookingCart[0].return.desDT
                                          )
                                        )
                                    ),
                                  ])
                                : _vm._e(),
                            ]),
                          ]),
                        ]),
                      ]),
                    ]),
                  ]
                ),
              ]),
            ]
          )
        : _vm._e(),
      _vm._v(" "),
      _vm.modulo === "services"
        ? _c(
            "div",
            {
              staticClass: "intro table-wrapper full-width hidden-table-sm box",
              staticStyle: { "border-spacing": "8px" },
            },
            [
              _c("div", { staticClass: "col-md-4 table-cell sdr-box" }, [
                _c("dl", { staticClass: "term-description" }, [
                  _c("dt", [
                    _vm._v(_vm._s(_vm.airline[_vm.getCurrentLocale]) + ":"),
                  ]),
                  _c("dd", [_vm._v("-")]),
                  _vm._v(" "),
                  _c("dt", [
                    _vm._v(_vm._s(_vm.flighttype[_vm.getCurrentLocale]) + ":"),
                  ]),
                  _c("dd", [_vm._v("Economy")]),
                  _vm._v(" "),
                  _c("dt", [
                    _vm._v(
                      _vm._s(_vm.cancellation[_vm.getCurrentLocale]) + ":"
                    ),
                  ]),
                  _c("dd", [
                    _vm._v(
                      _vm._s(_vm.avgpers[_vm.getCurrentLocale]) +
                        "/" +
                        _vm._s(_vm._f("rndAmntRUAFWZ")(65))
                    ),
                  ]),
                  _vm._v(" "),
                  _c("dt", [
                    _vm._v(
                      _vm._s(_vm.flightchange[_vm.getCurrentLocale]) + ":"
                    ),
                  ]),
                  _c("dd", [
                    _vm._v(
                      _vm._s(_vm.avgpers[_vm.getCurrentLocale]) +
                        "/" +
                        _vm._s(_vm._f("rndAmntRUAFWZ")(65))
                    ),
                  ]),
                ]),
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "col-md-8 table-cell" }, [
                _c(
                  "div",
                  { staticClass: "detailed-features booking-details" },
                  [
                    _c("div", { staticClass: "sdr-box" }, [
                      _vm.flightdirection === "outward"
                        ? _c("h4", { staticClass: "box-title" }, [
                            _vm._v(
                              _vm._s(_vm.from[_vm.getCurrentLocale]) +
                                " " +
                                _vm._s(_vm.getBookingDepArprtName) +
                                " " +
                                _vm._s(_vm.to[_vm.getCurrentLocale]) +
                                "  " +
                                _vm._s(_vm.getBookingDesArprtName)
                            ),
                            _c("small", [
                              _vm._v(
                                _vm._s(_vm.outwardflight[_vm.getCurrentLocale])
                              ),
                            ]),
                          ])
                        : _vm._e(),
                      _vm._v(" "),
                      _vm.flightdirection === "return" &&
                      _vm.getBookingDepArprtNameReturnToOther === null
                        ? _c("h4", { staticClass: "box-title" }, [
                            _vm._v(
                              _vm._s(_vm.from[_vm.getCurrentLocale]) +
                                " " +
                                _vm._s(_vm.getBookingDesArprtName) +
                                " " +
                                _vm._s(_vm.to[_vm.getCurrentLocale]) +
                                "  " +
                                _vm._s(_vm.getBookingDepArprtName)
                            ),
                            _c("small", [
                              _vm._v(
                                _vm._s(_vm.returnflight[_vm.getCurrentLocale])
                              ),
                            ]),
                          ])
                        : _vm._e(),
                      _vm._v(" "),
                      _vm.flightdirection === "return" &&
                      _vm.getBookingDepArprtNameReturnToOther !== null
                        ? _c("h4", { staticClass: "box-title" }, [
                            _vm._v(
                              _vm._s(_vm.from[_vm.getCurrentLocale]) +
                                " " +
                                _vm._s(
                                  _vm.getBookingDepArprtNameReturnToOther
                                ) +
                                " " +
                                _vm._s(_vm.to[_vm.getCurrentLocale]) +
                                "  " +
                                _vm._s(_vm.getBookingDesArprtNameReturnToOther)
                            ),
                            _c("small", [
                              _vm._v(
                                _vm._s(_vm.returnflight[_vm.getCurrentLocale])
                              ),
                            ]),
                          ])
                        : _vm._e(),
                    ]),
                    _vm._v(" "),
                    _c("div", { staticClass: "table-wrapper flights" }, [
                      _c("div", { staticClass: "table-row first-flight" }, [
                        _vm._m(0),
                        _vm._v(" "),
                        _c("div", { staticClass: "table-cell timing-detail" }, [
                          _c("div", { staticClass: "timing" }, [
                            _c("div", { staticClass: "check-in" }, [
                              _c("label", [
                                _vm._v(
                                  _vm._s(_vm.takeoff[_vm.getCurrentLocale])
                                ),
                              ]),
                              _vm._v(" "),
                              _vm.flightdirection === "outward"
                                ? _c("span", [
                                    _vm._v(
                                      _vm._s(
                                        _vm._f("dateFlightCart")(
                                          _vm.getBookingCart[0].outward.depDT
                                        )
                                      ) +
                                        ", " +
                                        _vm._s(
                                          _vm._f("momentTime")(
                                            _vm.getBookingCart[0].outward.depDT
                                          )
                                        )
                                    ),
                                  ])
                                : _vm._e(),
                              _vm._v(" "),
                              _vm.flightdirection === "return"
                                ? _c("span", [
                                    _vm._v(
                                      _vm._s(
                                        _vm._f("dateFlightCart")(
                                          _vm.getBookingCart[0].return.depDT
                                        )
                                      ) +
                                        ", " +
                                        _vm._s(
                                          _vm._f("momentTime")(
                                            _vm.getBookingCart[0].return.depDT
                                          )
                                        )
                                    ),
                                  ])
                                : _vm._e(),
                            ]),
                            _vm._v(" "),
                            _c("div", { staticClass: "duration text-center" }, [
                              _c("i", { staticClass: "soap-icon-clock" }),
                              _vm._v(" "),
                              _vm.flightdirection === "outward"
                                ? _c("span", [
                                    _vm._v(
                                      _vm._s(
                                        _vm._f("durationFlightCart")(
                                          _vm.getBookingCart[0].outward.dur
                                        )
                                      )
                                    ),
                                  ])
                                : _vm._e(),
                              _vm._v(" "),
                              _vm.flightdirection === "return"
                                ? _c("span", [
                                    _vm._v(
                                      _vm._s(
                                        _vm._f("durationFlightCart")(
                                          _vm.getBookingCart[0].return.dur
                                        )
                                      )
                                    ),
                                  ])
                                : _vm._e(),
                            ]),
                            _vm._v(" "),
                            _c("div", { staticClass: "check-out" }, [
                              _c("label", [
                                _vm._v(
                                  _vm._s(_vm.landing[_vm.getCurrentLocale])
                                ),
                              ]),
                              _vm._v(" "),
                              _vm.flightdirection === "outward"
                                ? _c("span", [
                                    _vm._v(
                                      _vm._s(
                                        _vm._f("dateFlightCart")(
                                          _vm.getBookingCart[0].outward.desDT
                                        )
                                      ) +
                                        ", " +
                                        _vm._s(
                                          _vm._f("momentTime")(
                                            _vm.getBookingCart[0].outward.desDT
                                          )
                                        )
                                    ),
                                  ])
                                : _vm._e(),
                              _vm._v(" "),
                              _vm.flightdirection === "return"
                                ? _c("span", [
                                    _vm._v(
                                      _vm._s(
                                        _vm._f("dateFlightCart")(
                                          _vm.getBookingCart[0].return.desDT
                                        )
                                      ) +
                                        ", " +
                                        _vm._s(
                                          _vm._f("momentTime")(
                                            _vm.getBookingCart[0].return.desDT
                                          )
                                        )
                                    ),
                                  ])
                                : _vm._e(),
                            ]),
                          ]),
                        ]),
                      ]),
                    ]),
                  ]
                ),
              ]),
            ]
          )
        : _vm._e(),
      _vm._v(" "),
      _vm._l(_vm.datatocatch, function (pax, index) {
        return _c(
          "div",
          {
            key: index,
            staticClass: "booking-section sdr-box",
            staticStyle: { padding: "0px", "padding-top": "30px" },
          },
          [
            _c(
              "h4",
              {
                staticClass: "paxheadline",
                staticStyle: { "margin-bottom": "0px" },
              },
              [
                _vm._v(
                  _vm._s(_vm.trnslPaxTypes(pax.type)) +
                    " " +
                    _vm._s(pax.counter) +
                    ": " +
                    _vm._s(
                      _vm.trnslPaxSalutations(pax.paxCredentials.salutation)
                    ) +
                    " " +
                    _vm._s(pax.paxCredentials.firstName) +
                    " " +
                    _vm._s(pax.paxCredentials.lastName) +
                    " (" +
                    _vm._s(_vm.born[_vm.getCurrentLocale]) +
                    ": " +
                    _vm._s(_vm._f("birthdate")(pax.paxCredentials.birthdate)) +
                    ")"
                ),
              ]
            ),
            _vm._v(" "),
            _vm.modulo === "booking" && _vm.mode === "direct"
              ? _c(
                  "a",
                  {
                    staticClass: "button btn-medium green pull-left uppercase",
                    on: {
                      click: function ($event) {
                        _vm.onClick_ZeroBooking2(_vm.flightdirection)
                      },
                    },
                  },
                  [_vm._v(_vm._s(_vm.setprice[_vm.getCurrentLocale]))]
                )
              : _vm._e(),
            _vm._v(" "),
            _vm.modulo === "booking" && _vm.mode === "direct"
              ? _c(
                  "a",
                  {
                    staticClass: "button btn-medium green pull-right uppercase",
                    on: {
                      click: function ($event) {
                        _vm.onClick_ZeroBooking(_vm.flightdirection)
                      },
                    },
                  },
                  [_vm._v(_vm._s(_vm.setzero[_vm.getCurrentLocale]))]
                )
              : _vm._e(),
            _c("br"),
            _c("br"),
            _vm._v(" "),
            _c("div", { staticClass: "table-cell cruise-itinerary" }, [
              _c(
                "div",
                {
                  staticClass: "sdr-box",
                  staticStyle: {
                    "padding-top": "0px",
                    "padding-bottom": "0px",
                    "padding-left": "0px",
                    "padding-right": "0px",
                  },
                },
                [
                  _vm.flightdirection === "outward"
                    ? _c("table", [
                        _c(
                          "tbody",
                          [
                            _c("tr", [
                              _vm.modulo === "booking" && _vm.mode !== "direct"
                                ? _c("td", [
                                    _vm._v(
                                      _vm._s(
                                        _vm.flightprice[_vm.getCurrentLocale]
                                      )
                                    ),
                                  ])
                                : _vm._e(),
                              _vm._v(" "),
                              _vm.modulo === "services"
                                ? _c("td", [
                                    _vm._v(
                                      _vm._s(
                                        _vm.flightpriceservices[
                                          _vm.getCurrentLocale
                                        ]
                                      )
                                    ),
                                  ])
                                : _vm._e(),
                              _vm._v(" "),
                              _c("td", [_vm._v(" ")]),
                              _vm._v(" "),
                              _vm.modulo === "booking" && _vm.mode !== "direct"
                                ? _c(
                                    "td",
                                    { staticClass: "total-price-value-small" },
                                    [
                                      _vm._v(
                                        _vm._s(
                                          _vm._f("rndAmntRUAFWZ")(
                                            pax.outward.totalprice !== undefined
                                              ? pax.outward.totalprice
                                              : "0"
                                          )
                                        )
                                      ),
                                    ]
                                  )
                                : _vm._e(),
                              _vm._v(" "),
                              _vm.modulo === "services"
                                ? _c(
                                    "td",
                                    { staticClass: "total-price-value-small" },
                                    [_vm._v(" - ")]
                                  )
                                : _vm._e(),
                              _vm._v(" "),
                              _vm.modulo === "booking" && _vm.mode === "direct"
                                ? _c("td", [
                                    _c("table", [
                                      _c("tbody", [
                                        _c("tr", [
                                          _c("td", [
                                            _vm._v(
                                              _vm._s(
                                                _vm.airfare[
                                                  _vm.getCurrentLocale
                                                ]
                                              )
                                            ),
                                          ]),
                                          _vm._v(" "),
                                          _vm._o(
                                            _c(
                                              "td",
                                              {
                                                staticClass:
                                                  "total-price-value-small",
                                                staticStyle: {
                                                  "padding-right": "25px",
                                                  color: "#2d3e52",
                                                  "font-weight": "stronger",
                                                },
                                              },
                                              [
                                                _vm._v(
                                                  _vm._s(
                                                    _vm._f("rndAmntRUAFWZ")(
                                                      pax.outward.price !==
                                                        undefined
                                                        ? pax.outward.price
                                                        : "0"
                                                    )
                                                  )
                                                ),
                                              ]
                                            ),
                                            0,
                                            index
                                          ),
                                          _vm._v(" "),
                                          _c(
                                            "td",
                                            {
                                              staticClass:
                                                "total-price-value-small",
                                            },
                                            [
                                              _c("input", {
                                                directives: [
                                                  {
                                                    name: "model",
                                                    rawName: "v-model",
                                                    value:
                                                      _vm.datatocatch[index]
                                                        .outward.price,
                                                    expression:
                                                      "datatocatch[index].outward.price",
                                                  },
                                                ],
                                                staticClass: "input-text",
                                                staticStyle: {
                                                  "text-align": "right",
                                                },
                                                attrs: {
                                                  type: "number",
                                                  step: ".01",
                                                },
                                                domProps: {
                                                  value:
                                                    _vm.datatocatch[index]
                                                      .outward.price,
                                                },
                                                on: {
                                                  input: function ($event) {
                                                    if (
                                                      $event.target.composing
                                                    ) {
                                                      return
                                                    }
                                                    _vm.$set(
                                                      _vm.datatocatch[index]
                                                        .outward,
                                                      "price",
                                                      $event.target.value
                                                    )
                                                  },
                                                },
                                              }),
                                            ]
                                          ),
                                        ]),
                                        _vm._v(" "),
                                        _c("tr", [
                                          _c("td", [
                                            _vm._v(
                                              _vm._s(
                                                _vm.airporttaxes[
                                                  _vm.getCurrentLocale
                                                ]
                                              )
                                            ),
                                          ]),
                                          _vm._v(" "),
                                          _vm._o(
                                            _c(
                                              "td",
                                              {
                                                staticClass:
                                                  "total-price-value-small",
                                                staticStyle: {
                                                  "padding-right": "25px",
                                                  color: "#2d3e52",
                                                  "font-weight": "stronger",
                                                },
                                              },
                                              [
                                                _vm._v(
                                                  _vm._s(
                                                    _vm._f("rndAmntRUAFWZ")(
                                                      pax.outward.taxes.air !==
                                                        undefined
                                                        ? pax.outward.taxes.air
                                                        : "0"
                                                    )
                                                  )
                                                ),
                                              ]
                                            ),
                                            1,
                                            index
                                          ),
                                          _vm._v(" "),
                                          _c(
                                            "td",
                                            {
                                              staticClass:
                                                "total-price-value-small",
                                            },
                                            [
                                              _c("input", {
                                                directives: [
                                                  {
                                                    name: "model",
                                                    rawName: "v-model",
                                                    value:
                                                      _vm.datatocatch[index]
                                                        .outward.taxes.air,
                                                    expression:
                                                      "datatocatch[index].outward.taxes.air",
                                                  },
                                                ],
                                                staticClass: "input-text",
                                                staticStyle: {
                                                  "text-align": "right",
                                                },
                                                attrs: {
                                                  type: "number",
                                                  step: ".01",
                                                },
                                                domProps: {
                                                  value:
                                                    _vm.datatocatch[index]
                                                      .outward.taxes.air,
                                                },
                                                on: {
                                                  input: function ($event) {
                                                    if (
                                                      $event.target.composing
                                                    ) {
                                                      return
                                                    }
                                                    _vm.$set(
                                                      _vm.datatocatch[index]
                                                        .outward.taxes,
                                                      "air",
                                                      $event.target.value
                                                    )
                                                  },
                                                },
                                              }),
                                            ]
                                          ),
                                        ]),
                                        _vm._v(" "),
                                        _c("tr", [
                                          _c("td", [
                                            _vm._v(
                                              _vm._s(
                                                _vm.aviationtax[
                                                  _vm.getCurrentLocale
                                                ]
                                              )
                                            ),
                                          ]),
                                          _vm._v(" "),
                                          _vm._o(
                                            _c(
                                              "td",
                                              {
                                                staticClass:
                                                  "total-price-value-small",
                                                staticStyle: {
                                                  "padding-right": "25px",
                                                  color: "#2d3e52",
                                                  "font-weight": "stronger",
                                                },
                                              },
                                              [
                                                _vm._v(
                                                  _vm._s(
                                                    _vm._f("rndAmntRUAFWZ")(
                                                      pax.outward.taxes.avia !==
                                                        undefined
                                                        ? pax.outward.taxes.avia
                                                        : "0"
                                                    )
                                                  )
                                                ),
                                              ]
                                            ),
                                            2,
                                            index
                                          ),
                                          _vm._v(" "),
                                          _c(
                                            "td",
                                            {
                                              staticClass:
                                                "total-price-value-small",
                                            },
                                            [
                                              _c("input", {
                                                directives: [
                                                  {
                                                    name: "model",
                                                    rawName: "v-model",
                                                    value:
                                                      _vm.datatocatch[index]
                                                        .outward.taxes.avia,
                                                    expression:
                                                      "datatocatch[index].outward.taxes.avia",
                                                  },
                                                ],
                                                staticClass: "input-text",
                                                staticStyle: {
                                                  "text-align": "right",
                                                },
                                                attrs: {
                                                  type: "number",
                                                  step: ".01",
                                                },
                                                domProps: {
                                                  value:
                                                    _vm.datatocatch[index]
                                                      .outward.taxes.avia,
                                                },
                                                on: {
                                                  input: function ($event) {
                                                    if (
                                                      $event.target.composing
                                                    ) {
                                                      return
                                                    }
                                                    _vm.$set(
                                                      _vm.datatocatch[index]
                                                        .outward.taxes,
                                                      "avia",
                                                      $event.target.value
                                                    )
                                                  },
                                                },
                                              }),
                                            ]
                                          ),
                                        ]),
                                        _vm._v(" "),
                                        _c("tr", [
                                          _c("td", [
                                            _vm._v(
                                              _vm._s(
                                                _vm.kerosenesurcharge[
                                                  _vm.getCurrentLocale
                                                ]
                                              )
                                            ),
                                          ]),
                                          _vm._v(" "),
                                          _vm._o(
                                            _c(
                                              "td",
                                              {
                                                staticClass:
                                                  "total-price-value-small",
                                                staticStyle: {
                                                  "padding-right": "25px",
                                                  color: "#2d3e52",
                                                  "font-weight": "stronger",
                                                },
                                              },
                                              [
                                                _vm._v(
                                                  _vm._s(
                                                    _vm._f("rndAmntRUAFWZ")(
                                                      pax.outward.taxes.fuel !==
                                                        undefined
                                                        ? pax.outward.taxes.fuel
                                                        : "0"
                                                    )
                                                  )
                                                ),
                                              ]
                                            ),
                                            3,
                                            index
                                          ),
                                          _vm._v(" "),
                                          _c(
                                            "td",
                                            {
                                              staticClass:
                                                "total-price-value-small",
                                            },
                                            [
                                              _c("input", {
                                                directives: [
                                                  {
                                                    name: "model",
                                                    rawName: "v-model",
                                                    value:
                                                      _vm.datatocatch[index]
                                                        .outward.taxes.fuel,
                                                    expression:
                                                      "datatocatch[index].outward.taxes.fuel",
                                                  },
                                                ],
                                                staticClass: "input-text",
                                                staticStyle: {
                                                  "text-align": "right",
                                                },
                                                attrs: {
                                                  type: "number",
                                                  step: ".01",
                                                },
                                                domProps: {
                                                  value:
                                                    _vm.datatocatch[index]
                                                      .outward.taxes.fuel,
                                                },
                                                on: {
                                                  input: function ($event) {
                                                    if (
                                                      $event.target.composing
                                                    ) {
                                                      return
                                                    }
                                                    _vm.$set(
                                                      _vm.datatocatch[index]
                                                        .outward.taxes,
                                                      "fuel",
                                                      $event.target.value
                                                    )
                                                  },
                                                },
                                              }),
                                            ]
                                          ),
                                        ]),
                                        _vm._v(" "),
                                        _c("tr", [
                                          _c("td", [
                                            _vm._v(
                                              _vm._s(
                                                _vm.securitycharges[
                                                  _vm.getCurrentLocale
                                                ]
                                              )
                                            ),
                                          ]),
                                          _vm._v(" "),
                                          _vm._o(
                                            _c(
                                              "td",
                                              {
                                                staticClass:
                                                  "total-price-value-small",
                                                staticStyle: {
                                                  "padding-right": "25px",
                                                  color: "#2d3e52",
                                                  "font-weight": "stronger",
                                                },
                                              },
                                              [
                                                _vm._v(
                                                  _vm._s(
                                                    _vm._f("rndAmntRUAFWZ")(
                                                      pax.outward.taxes.sec !==
                                                        undefined
                                                        ? pax.outward.taxes.sec
                                                        : "0"
                                                    )
                                                  )
                                                ),
                                              ]
                                            ),
                                            4,
                                            index
                                          ),
                                          _vm._v(" "),
                                          _c(
                                            "td",
                                            {
                                              staticClass:
                                                "total-price-value-small",
                                            },
                                            [
                                              _c("input", {
                                                directives: [
                                                  {
                                                    name: "model",
                                                    rawName: "v-model",
                                                    value:
                                                      _vm.datatocatch[index]
                                                        .outward.taxes.sec,
                                                    expression:
                                                      "datatocatch[index].outward.taxes.sec",
                                                  },
                                                ],
                                                staticClass: "input-text",
                                                staticStyle: {
                                                  "text-align": "right",
                                                },
                                                attrs: {
                                                  type: "number",
                                                  step: ".01",
                                                },
                                                domProps: {
                                                  value:
                                                    _vm.datatocatch[index]
                                                      .outward.taxes.sec,
                                                },
                                                on: {
                                                  input: function ($event) {
                                                    if (
                                                      $event.target.composing
                                                    ) {
                                                      return
                                                    }
                                                    _vm.$set(
                                                      _vm.datatocatch[index]
                                                        .outward.taxes,
                                                      "sec",
                                                      $event.target.value
                                                    )
                                                  },
                                                },
                                              }),
                                            ]
                                          ),
                                        ]),
                                        _vm._v(" "),
                                        _c("tr", [
                                          _c("td", [
                                            _vm._v(
                                              _vm._s(
                                                _vm.servicecharges[
                                                  _vm.getCurrentLocale
                                                ]
                                              )
                                            ),
                                          ]),
                                          _vm._v(" "),
                                          _vm._o(
                                            _c(
                                              "td",
                                              {
                                                staticClass:
                                                  "total-price-value-small",
                                                staticStyle: {
                                                  "padding-right": "25px",
                                                  color: "#2d3e52",
                                                  "font-weight": "stronger",
                                                },
                                              },
                                              [
                                                _vm._v(
                                                  _vm._s(
                                                    _vm._f("rndAmntRUAFWZ")(
                                                      pax.outward.taxes.srvc !==
                                                        undefined
                                                        ? pax.outward.taxes.srvc
                                                        : "0"
                                                    )
                                                  )
                                                ),
                                              ]
                                            ),
                                            5,
                                            index
                                          ),
                                          _vm._v(" "),
                                          _c(
                                            "td",
                                            {
                                              staticClass:
                                                "total-price-value-small",
                                            },
                                            [
                                              _c("input", {
                                                directives: [
                                                  {
                                                    name: "model",
                                                    rawName: "v-model",
                                                    value:
                                                      _vm.datatocatch[index]
                                                        .outward.taxes.srvc,
                                                    expression:
                                                      "datatocatch[index].outward.taxes.srvc",
                                                  },
                                                ],
                                                staticClass: "input-text",
                                                staticStyle: {
                                                  "text-align": "right",
                                                },
                                                attrs: {
                                                  type: "number",
                                                  step: ".01",
                                                },
                                                domProps: {
                                                  value:
                                                    _vm.datatocatch[index]
                                                      .outward.taxes.srvc,
                                                },
                                                on: {
                                                  input: function ($event) {
                                                    if (
                                                      $event.target.composing
                                                    ) {
                                                      return
                                                    }
                                                    _vm.$set(
                                                      _vm.datatocatch[index]
                                                        .outward.taxes,
                                                      "srvc",
                                                      $event.target.value
                                                    )
                                                  },
                                                },
                                              }),
                                            ]
                                          ),
                                        ]),
                                      ]),
                                    ]),
                                  ])
                                : _vm._e(),
                            ]),
                            _vm._v(" "),
                            pax.outward_seat.seatno !== undefined &&
                            _vm.mode === "normal"
                              ? _c("tr", [
                                  _c("td", [
                                    _vm._v(
                                      _vm._s(_vm.seat[_vm.getCurrentLocale]) +
                                        ": "
                                    ),
                                    _c("b", [
                                      _vm._v(
                                        _vm._s(
                                          _vm._f("truncate")(
                                            pax.outward_seat.seatno,
                                            17,
                                            "..."
                                          )
                                        )
                                      ),
                                    ]),
                                  ]),
                                  _vm._v(" "),
                                  _c("td", [_vm._v(" ")]),
                                  _vm._v(" "),
                                  _c(
                                    "td",
                                    { staticClass: "total-price-value-small" },
                                    [
                                      _vm._v(
                                        _vm._s(
                                          _vm._f("rndAmntRUAFWZ")(
                                            pax.outward_seat.price !== undefined
                                              ? pax.outward_seat.price
                                              : "0"
                                          )
                                        )
                                      ),
                                    ]
                                  ),
                                ])
                              : _vm._e(),
                            _vm._v(" "),
                            pax.outward_seat.seatno !== undefined &&
                            _vm.mode === "direct"
                              ? _c("tr", [
                                  _c("td", [
                                    _vm._v(
                                      _vm._s(_vm.seat[_vm.getCurrentLocale]) +
                                        ": "
                                    ),
                                    _c("b", [
                                      _vm._v(
                                        _vm._s(
                                          _vm._f("truncate")(
                                            pax.outward_seat.seatno,
                                            17,
                                            "..."
                                          )
                                        )
                                      ),
                                    ]),
                                  ]),
                                  _vm._v(" "),
                                  _c("td", [_vm._v(" ")]),
                                  _vm._v(" "),
                                  _c(
                                    "td",
                                    { staticClass: "total-price-value-small" },
                                    [
                                      _c("input", {
                                        directives: [
                                          {
                                            name: "model",
                                            rawName: "v-model",
                                            value:
                                              _vm.datatocatch[index]
                                                .outward_seat.price,
                                            expression:
                                              "datatocatch[index].outward_seat.price",
                                          },
                                        ],
                                        staticClass: "input-text",
                                        staticStyle: { "text-align": "right" },
                                        attrs: { type: "number", step: ".01" },
                                        domProps: {
                                          value:
                                            _vm.datatocatch[index].outward_seat
                                              .price,
                                        },
                                        on: {
                                          input: function ($event) {
                                            if ($event.target.composing) {
                                              return
                                            }
                                            _vm.$set(
                                              _vm.datatocatch[index]
                                                .outward_seat,
                                              "price",
                                              $event.target.value
                                            )
                                          },
                                        },
                                      }),
                                    ]
                                  ),
                                ])
                              : _vm._e(),
                            _vm._v(" "),
                            _vm._l(pax.outward_srvcs, function (srvcs, index2) {
                              return _c("tr", { key: index2 }, [
                                _c("td", [_vm._v(_vm._s(srvcs.description))]),
                                _vm._v(" "),
                                _c(
                                  "td",
                                  {
                                    staticStyle: {
                                      "text-transform": "none",
                                      "text-align": "center",
                                    },
                                  },
                                  [
                                    srvcs.userInputSrvcsDetails_Count > 1
                                      ? _c("span", [
                                          _vm._v(
                                            _vm._s(
                                              srvcs.userInputSrvcsDetails_Count
                                            ) +
                                              "x a " +
                                              _vm._s(
                                                _vm._f("rndAmntRUAFWZ")(
                                                  srvcs.price
                                                )
                                              )
                                          ),
                                        ])
                                      : _vm._e(),
                                  ]
                                ),
                                _vm._v(" "),
                                _vm.mode === "normal"
                                  ? _c(
                                      "td",
                                      {
                                        staticClass: "total-price-value-small",
                                      },
                                      [
                                        _vm._v(
                                          "\n                                " +
                                            _vm._s(
                                              _vm._f("rndAmntRUAFWZ")(
                                                srvcs.price !== undefined
                                                  ? parseFloat(srvcs.price) *
                                                      parseFloat(
                                                        srvcs.userInputSrvcsDetails_Count
                                                      )
                                                  : "0"
                                              )
                                            ) +
                                            "\n                            "
                                        ),
                                      ]
                                    )
                                  : _vm._e(),
                                _vm._v(" "),
                                _vm.mode === "direct"
                                  ? _c(
                                      "td",
                                      {
                                        staticClass: "total-price-value-small",
                                      },
                                      [
                                        _c("input", {
                                          directives: [
                                            {
                                              name: "model",
                                              rawName: "v-model",
                                              value:
                                                _vm.datatocatch[index]
                                                  .outward_srvcs[index2].price,
                                              expression:
                                                "datatocatch[index].outward_srvcs[index2].price",
                                            },
                                          ],
                                          staticClass: "input-text",
                                          staticStyle: {
                                            "text-align": "right",
                                          },
                                          attrs: {
                                            type: "number",
                                            step: ".01",
                                          },
                                          domProps: {
                                            value:
                                              _vm.datatocatch[index]
                                                .outward_srvcs[index2].price,
                                          },
                                          on: {
                                            input: function ($event) {
                                              if ($event.target.composing) {
                                                return
                                              }
                                              _vm.$set(
                                                _vm.datatocatch[index]
                                                  .outward_srvcs[index2],
                                                "price",
                                                $event.target.value
                                              )
                                            },
                                          },
                                        }),
                                      ]
                                    )
                                  : _vm._e(),
                              ])
                            }),
                          ],
                          2
                        ),
                      ])
                    : _vm._e(),
                  _vm._v(" "),
                  _vm.flightdirection === "return"
                    ? _c("table", [
                        _c(
                          "tbody",
                          [
                            _c("tr", [
                              _vm.modulo === "booking" && _vm.mode !== "direct"
                                ? _c("td", [
                                    _vm._v(
                                      _vm._s(
                                        _vm.flightprice[_vm.getCurrentLocale]
                                      )
                                    ),
                                  ])
                                : _vm._e(),
                              _vm._v(" "),
                              _vm.modulo === "services"
                                ? _c("td", [
                                    _vm._v(
                                      _vm._s(
                                        _vm.flightpriceservices[
                                          _vm.getCurrentLocale
                                        ]
                                      )
                                    ),
                                  ])
                                : _vm._e(),
                              _vm._v(" "),
                              _c("td", [_vm._v(" ")]),
                              _vm._v(" "),
                              _vm.modulo === "booking" && _vm.mode !== "direct"
                                ? _c(
                                    "td",
                                    { staticClass: "total-price-value-small" },
                                    [
                                      _vm._v(
                                        _vm._s(
                                          _vm._f("rndAmntRUAFWZ")(
                                            pax.return.totalprice !== undefined
                                              ? pax.return.totalprice
                                              : "0"
                                          )
                                        )
                                      ),
                                    ]
                                  )
                                : _vm._e(),
                              _vm._v(" "),
                              _vm.modulo === "services"
                                ? _c(
                                    "td",
                                    { staticClass: "total-price-value-small" },
                                    [_vm._v(" - ")]
                                  )
                                : _vm._e(),
                              _vm._v(" "),
                              _vm.modulo === "booking" && _vm.mode === "direct"
                                ? _c("td", [
                                    _c("table", [
                                      _c("tbody", [
                                        _c("tr", [
                                          _c("td", [
                                            _vm._v(
                                              _vm._s(
                                                _vm.airfare[
                                                  _vm.getCurrentLocale
                                                ]
                                              )
                                            ),
                                          ]),
                                          _vm._v(" "),
                                          _vm._o(
                                            _c(
                                              "td",
                                              {
                                                staticClass:
                                                  "total-price-value-small",
                                                staticStyle: {
                                                  "padding-right": "25px",
                                                },
                                              },
                                              [
                                                _vm._v(
                                                  _vm._s(
                                                    _vm._f("rndAmntRUAFWZ")(
                                                      pax.return.price !==
                                                        undefined
                                                        ? pax.return.price
                                                        : "0"
                                                    )
                                                  )
                                                ),
                                              ]
                                            ),
                                            6,
                                            index
                                          ),
                                          _vm._v(" "),
                                          _c(
                                            "td",
                                            {
                                              staticClass:
                                                "total-price-value-small",
                                            },
                                            [
                                              _c("input", {
                                                directives: [
                                                  {
                                                    name: "model",
                                                    rawName: "v-model",
                                                    value:
                                                      _vm.datatocatch[index]
                                                        .return.price,
                                                    expression:
                                                      "datatocatch[index].return.price",
                                                  },
                                                ],
                                                staticClass: "input-text",
                                                staticStyle: {
                                                  "text-align": "right",
                                                },
                                                attrs: {
                                                  type: "number",
                                                  step: ".01",
                                                },
                                                domProps: {
                                                  value:
                                                    _vm.datatocatch[index]
                                                      .return.price,
                                                },
                                                on: {
                                                  input: function ($event) {
                                                    if (
                                                      $event.target.composing
                                                    ) {
                                                      return
                                                    }
                                                    _vm.$set(
                                                      _vm.datatocatch[index]
                                                        .return,
                                                      "price",
                                                      $event.target.value
                                                    )
                                                  },
                                                },
                                              }),
                                            ]
                                          ),
                                        ]),
                                        _vm._v(" "),
                                        _c("tr", [
                                          _c("td", [
                                            _vm._v(
                                              _vm._s(
                                                _vm.airporttaxes[
                                                  _vm.getCurrentLocale
                                                ]
                                              )
                                            ),
                                          ]),
                                          _vm._v(" "),
                                          _vm._o(
                                            _c(
                                              "td",
                                              {
                                                staticClass:
                                                  "total-price-value-small",
                                                staticStyle: {
                                                  "padding-right": "25px",
                                                },
                                              },
                                              [
                                                _vm._v(
                                                  _vm._s(
                                                    _vm._f("rndAmntRUAFWZ")(
                                                      pax.return.taxes.air !==
                                                        undefined
                                                        ? pax.return.taxes.air
                                                        : "0"
                                                    )
                                                  )
                                                ),
                                              ]
                                            ),
                                            7,
                                            index
                                          ),
                                          _vm._v(" "),
                                          _c(
                                            "td",
                                            {
                                              staticClass:
                                                "total-price-value-small",
                                            },
                                            [
                                              _c("input", {
                                                directives: [
                                                  {
                                                    name: "model",
                                                    rawName: "v-model",
                                                    value:
                                                      _vm.datatocatch[index]
                                                        .return.taxes.air,
                                                    expression:
                                                      "datatocatch[index].return.taxes.air",
                                                  },
                                                ],
                                                staticClass: "input-text",
                                                staticStyle: {
                                                  "text-align": "right",
                                                },
                                                attrs: {
                                                  type: "number",
                                                  step: ".01",
                                                },
                                                domProps: {
                                                  value:
                                                    _vm.datatocatch[index]
                                                      .return.taxes.air,
                                                },
                                                on: {
                                                  input: function ($event) {
                                                    if (
                                                      $event.target.composing
                                                    ) {
                                                      return
                                                    }
                                                    _vm.$set(
                                                      _vm.datatocatch[index]
                                                        .return.taxes,
                                                      "air",
                                                      $event.target.value
                                                    )
                                                  },
                                                },
                                              }),
                                            ]
                                          ),
                                        ]),
                                        _vm._v(" "),
                                        _c("tr", [
                                          _c("td", [
                                            _vm._v(
                                              _vm._s(
                                                _vm.aviationtax[
                                                  _vm.getCurrentLocale
                                                ]
                                              )
                                            ),
                                          ]),
                                          _vm._v(" "),
                                          _vm._o(
                                            _c(
                                              "td",
                                              {
                                                staticClass:
                                                  "total-price-value-small",
                                                staticStyle: {
                                                  "padding-right": "25px",
                                                },
                                              },
                                              [
                                                _vm._v(
                                                  _vm._s(
                                                    _vm._f("rndAmntRUAFWZ")(
                                                      pax.return.taxes.avia !==
                                                        undefined
                                                        ? pax.return.taxes.avia
                                                        : "0"
                                                    )
                                                  )
                                                ),
                                              ]
                                            ),
                                            8,
                                            index
                                          ),
                                          _vm._v(" "),
                                          _c(
                                            "td",
                                            {
                                              staticClass:
                                                "total-price-value-small",
                                            },
                                            [
                                              _c("input", {
                                                directives: [
                                                  {
                                                    name: "model",
                                                    rawName: "v-model",
                                                    value:
                                                      _vm.datatocatch[index]
                                                        .return.taxes.avia,
                                                    expression:
                                                      "datatocatch[index].return.taxes.avia",
                                                  },
                                                ],
                                                staticClass: "input-text",
                                                staticStyle: {
                                                  "text-align": "right",
                                                },
                                                attrs: {
                                                  type: "number",
                                                  step: ".01",
                                                },
                                                domProps: {
                                                  value:
                                                    _vm.datatocatch[index]
                                                      .return.taxes.avia,
                                                },
                                                on: {
                                                  input: function ($event) {
                                                    if (
                                                      $event.target.composing
                                                    ) {
                                                      return
                                                    }
                                                    _vm.$set(
                                                      _vm.datatocatch[index]
                                                        .return.taxes,
                                                      "avia",
                                                      $event.target.value
                                                    )
                                                  },
                                                },
                                              }),
                                            ]
                                          ),
                                        ]),
                                        _vm._v(" "),
                                        _c("tr", [
                                          _c("td", [
                                            _vm._v(
                                              _vm._s(
                                                _vm.kerosenesurcharge[
                                                  _vm.getCurrentLocale
                                                ]
                                              )
                                            ),
                                          ]),
                                          _vm._v(" "),
                                          _vm._o(
                                            _c(
                                              "td",
                                              {
                                                staticClass:
                                                  "total-price-value-small",
                                                staticStyle: {
                                                  "padding-right": "25px",
                                                },
                                              },
                                              [
                                                _vm._v(
                                                  _vm._s(
                                                    _vm._f("rndAmntRUAFWZ")(
                                                      pax.return.taxes.fuel !==
                                                        undefined
                                                        ? pax.return.taxes.fuel
                                                        : "0"
                                                    )
                                                  )
                                                ),
                                              ]
                                            ),
                                            9,
                                            index
                                          ),
                                          _vm._v(" "),
                                          _c(
                                            "td",
                                            {
                                              staticClass:
                                                "total-price-value-small",
                                            },
                                            [
                                              _c("input", {
                                                directives: [
                                                  {
                                                    name: "model",
                                                    rawName: "v-model",
                                                    value:
                                                      _vm.datatocatch[index]
                                                        .return.taxes.fuel,
                                                    expression:
                                                      "datatocatch[index].return.taxes.fuel",
                                                  },
                                                ],
                                                staticClass: "input-text",
                                                staticStyle: {
                                                  "text-align": "right",
                                                },
                                                attrs: {
                                                  type: "number",
                                                  step: ".01",
                                                },
                                                domProps: {
                                                  value:
                                                    _vm.datatocatch[index]
                                                      .return.taxes.fuel,
                                                },
                                                on: {
                                                  input: function ($event) {
                                                    if (
                                                      $event.target.composing
                                                    ) {
                                                      return
                                                    }
                                                    _vm.$set(
                                                      _vm.datatocatch[index]
                                                        .return.taxes,
                                                      "fuel",
                                                      $event.target.value
                                                    )
                                                  },
                                                },
                                              }),
                                            ]
                                          ),
                                        ]),
                                        _vm._v(" "),
                                        _c("tr", [
                                          _c("td", [
                                            _vm._v(
                                              _vm._s(
                                                _vm.securitycharges[
                                                  _vm.getCurrentLocale
                                                ]
                                              )
                                            ),
                                          ]),
                                          _vm._v(" "),
                                          _vm._o(
                                            _c(
                                              "td",
                                              {
                                                staticClass:
                                                  "total-price-value-small",
                                                staticStyle: {
                                                  "padding-right": "25px",
                                                },
                                              },
                                              [
                                                _vm._v(
                                                  _vm._s(
                                                    _vm._f("rndAmntRUAFWZ")(
                                                      pax.return.taxes.sec !==
                                                        undefined
                                                        ? pax.return.taxes.sec
                                                        : "0"
                                                    )
                                                  )
                                                ),
                                              ]
                                            ),
                                            10,
                                            index
                                          ),
                                          _vm._v(" "),
                                          _c(
                                            "td",
                                            {
                                              staticClass:
                                                "total-price-value-small",
                                            },
                                            [
                                              _c("input", {
                                                directives: [
                                                  {
                                                    name: "model",
                                                    rawName: "v-model",
                                                    value:
                                                      _vm.datatocatch[index]
                                                        .return.taxes.sec,
                                                    expression:
                                                      "datatocatch[index].return.taxes.sec",
                                                  },
                                                ],
                                                staticClass: "input-text",
                                                staticStyle: {
                                                  "text-align": "right",
                                                },
                                                attrs: {
                                                  type: "number",
                                                  step: ".01",
                                                },
                                                domProps: {
                                                  value:
                                                    _vm.datatocatch[index]
                                                      .return.taxes.sec,
                                                },
                                                on: {
                                                  input: function ($event) {
                                                    if (
                                                      $event.target.composing
                                                    ) {
                                                      return
                                                    }
                                                    _vm.$set(
                                                      _vm.datatocatch[index]
                                                        .return.taxes,
                                                      "sec",
                                                      $event.target.value
                                                    )
                                                  },
                                                },
                                              }),
                                            ]
                                          ),
                                        ]),
                                        _vm._v(" "),
                                        _c("tr", [
                                          _c("td", [
                                            _vm._v(
                                              _vm._s(
                                                _vm.servicecharges[
                                                  _vm.getCurrentLocale
                                                ]
                                              )
                                            ),
                                          ]),
                                          _vm._v(" "),
                                          _vm._o(
                                            _c(
                                              "td",
                                              {
                                                staticClass:
                                                  "total-price-value-small",
                                                staticStyle: {
                                                  "padding-right": "25px",
                                                },
                                              },
                                              [
                                                _vm._v(
                                                  _vm._s(
                                                    _vm._f("rndAmntRUAFWZ")(
                                                      pax.return.taxes.srvc !==
                                                        undefined
                                                        ? pax.return.taxes.srvc
                                                        : "0"
                                                    )
                                                  )
                                                ),
                                              ]
                                            ),
                                            11,
                                            index
                                          ),
                                          _vm._v(" "),
                                          _c(
                                            "td",
                                            {
                                              staticClass:
                                                "total-price-value-small",
                                            },
                                            [
                                              _c("input", {
                                                directives: [
                                                  {
                                                    name: "model",
                                                    rawName: "v-model",
                                                    value:
                                                      _vm.datatocatch[index]
                                                        .return.taxes.srvc,
                                                    expression:
                                                      "datatocatch[index].return.taxes.srvc",
                                                  },
                                                ],
                                                staticClass: "input-text",
                                                staticStyle: {
                                                  "text-align": "right",
                                                },
                                                attrs: {
                                                  type: "number",
                                                  step: ".01",
                                                },
                                                domProps: {
                                                  value:
                                                    _vm.datatocatch[index]
                                                      .return.taxes.srvc,
                                                },
                                                on: {
                                                  input: function ($event) {
                                                    if (
                                                      $event.target.composing
                                                    ) {
                                                      return
                                                    }
                                                    _vm.$set(
                                                      _vm.datatocatch[index]
                                                        .return.taxes,
                                                      "srvc",
                                                      $event.target.value
                                                    )
                                                  },
                                                },
                                              }),
                                            ]
                                          ),
                                        ]),
                                      ]),
                                    ]),
                                  ])
                                : _vm._e(),
                            ]),
                            _vm._v(" "),
                            pax.return_seat.seatno !== undefined &&
                            _vm.mode === "normal"
                              ? _c("tr", [
                                  _c("td", [
                                    _vm._v(
                                      _vm._s(_vm.seat[_vm.getCurrentLocale]) +
                                        ": "
                                    ),
                                    _c("b", [
                                      _vm._v(
                                        _vm._s(
                                          _vm._f("truncate")(
                                            pax.return_seat.seatno,
                                            17,
                                            "..."
                                          )
                                        )
                                      ),
                                    ]),
                                  ]),
                                  _vm._v(" "),
                                  _c("td", [_vm._v(" ")]),
                                  _vm._v(" "),
                                  _c(
                                    "td",
                                    { staticClass: "total-price-value-small" },
                                    [
                                      _vm._v(
                                        _vm._s(
                                          _vm._f("rndAmntRUAFWZ")(
                                            pax.return_seat.price !== undefined
                                              ? pax.return_seat.price
                                              : "0"
                                          )
                                        )
                                      ),
                                    ]
                                  ),
                                ])
                              : _vm._e(),
                            _vm._v(" "),
                            pax.outward_seat.seatno !== undefined &&
                            _vm.mode === "direct"
                              ? _c("tr", [
                                  _c("td", [
                                    _vm._v(
                                      _vm._s(_vm.seat[_vm.getCurrentLocale]) +
                                        ": "
                                    ),
                                    _c("b", [
                                      _vm._v(
                                        _vm._s(
                                          _vm._f("truncate")(
                                            pax.return_seat.seatno,
                                            17,
                                            "..."
                                          )
                                        )
                                      ),
                                    ]),
                                  ]),
                                  _vm._v(" "),
                                  _c("td", [_vm._v(" ")]),
                                  _vm._v(" "),
                                  _c(
                                    "td",
                                    { staticClass: "total-price-value-small" },
                                    [
                                      _c("input", {
                                        directives: [
                                          {
                                            name: "model",
                                            rawName: "v-model",
                                            value:
                                              _vm.datatocatch[index].return_seat
                                                .price,
                                            expression:
                                              "datatocatch[index].return_seat.price",
                                          },
                                        ],
                                        staticClass: "input-text",
                                        staticStyle: { "text-align": "right" },
                                        attrs: { type: "number", step: ".01" },
                                        domProps: {
                                          value:
                                            _vm.datatocatch[index].return_seat
                                              .price,
                                        },
                                        on: {
                                          input: function ($event) {
                                            if ($event.target.composing) {
                                              return
                                            }
                                            _vm.$set(
                                              _vm.datatocatch[index]
                                                .return_seat,
                                              "price",
                                              $event.target.value
                                            )
                                          },
                                        },
                                      }),
                                    ]
                                  ),
                                ])
                              : _vm._e(),
                            _vm._v(" "),
                            _vm._l(pax.return_srvcs, function (srvcs, index2) {
                              return _c("tr", { key: index2 }, [
                                _c("td", [_vm._v(_vm._s(srvcs.description))]),
                                _vm._v(" "),
                                _c(
                                  "td",
                                  {
                                    staticStyle: {
                                      "text-transform": "none",
                                      "text-align": "center",
                                    },
                                  },
                                  [
                                    srvcs.userInputSrvcsDetails_Count > 1
                                      ? _c("span", [
                                          _vm._v(
                                            _vm._s(
                                              srvcs.userInputSrvcsDetails_Count
                                            ) +
                                              "x a " +
                                              _vm._s(
                                                _vm._f("rndAmntRUAFWZ")(
                                                  srvcs.price
                                                )
                                              )
                                          ),
                                        ])
                                      : _vm._e(),
                                  ]
                                ),
                                _vm._v(" "),
                                _vm.mode === "normal"
                                  ? _c(
                                      "td",
                                      {
                                        staticClass: "total-price-value-small",
                                      },
                                      [
                                        _vm._v(
                                          "\n                                " +
                                            _vm._s(
                                              _vm._f("rndAmntRUAFWZ")(
                                                srvcs.price !== undefined
                                                  ? parseFloat(srvcs.price) *
                                                      parseFloat(
                                                        srvcs.userInputSrvcsDetails_Count
                                                      )
                                                  : "0"
                                              )
                                            ) +
                                            "\n                            "
                                        ),
                                      ]
                                    )
                                  : _vm._e(),
                                _vm._v(" "),
                                _vm.mode === "direct"
                                  ? _c(
                                      "td",
                                      {
                                        staticClass: "total-price-value-small",
                                      },
                                      [
                                        _c("input", {
                                          directives: [
                                            {
                                              name: "model",
                                              rawName: "v-model",
                                              value:
                                                _vm.datatocatch[index]
                                                  .return_srvcs[index2].price,
                                              expression:
                                                "datatocatch[index].return_srvcs[index2].price",
                                            },
                                          ],
                                          staticClass: "input-text",
                                          staticStyle: {
                                            "text-align": "right",
                                          },
                                          attrs: {
                                            type: "number",
                                            step: ".01",
                                          },
                                          domProps: {
                                            value:
                                              _vm.datatocatch[index]
                                                .return_srvcs[index2].price,
                                          },
                                          on: {
                                            input: function ($event) {
                                              if ($event.target.composing) {
                                                return
                                              }
                                              _vm.$set(
                                                _vm.datatocatch[index]
                                                  .return_srvcs[index2],
                                                "price",
                                                $event.target.value
                                              )
                                            },
                                          },
                                        }),
                                      ]
                                    )
                                  : _vm._e(),
                              ])
                            }),
                          ],
                          2
                        ),
                      ])
                    : _vm._e(),
                ]
              ),
            ]),
          ]
        )
      }),
      _vm._v(" "),
      _vm.flightdirection === "outward" && _vm.mode !== "direct"
        ? _c(
            "div",
            {
              staticClass: "booking-details sdr-box",
              staticStyle: { "padding-left": "0px", "padding-right": "0px" },
            },
            [
              _c(
                "article",
                {
                  staticClass: "detailed-logo",
                  staticStyle: { padding: "0px" },
                },
                [
                  _c("div", { staticClass: "details" }, [
                    _c("dl", { staticClass: "other-details" }, [
                      _c("dt", { staticClass: "total-price" }, [
                        _vm._v(
                          _vm._s(_vm.totaloutwardprice[_vm.getCurrentLocale]) +
                            ":"
                        ),
                      ]),
                      _c("dd", { staticClass: "total-price-value" }, [
                        _vm._v(
                          _vm._s(
                            _vm._f("rndAmntRUAFWZ")(
                              _vm.getBookingCartOutwardTotal
                            )
                          )
                        ),
                      ]),
                    ]),
                  ]),
                ]
              ),
            ]
          )
        : _vm._e(),
      _vm._v(" "),
      _vm.flightdirection === "return" && _vm.mode !== "direct"
        ? _c(
            "div",
            {
              staticClass: "booking-details sdr-box",
              staticStyle: { "padding-left": "0px", "padding-right": "0px" },
            },
            [
              _c(
                "article",
                {
                  staticClass: "detailed-logo",
                  staticStyle: { padding: "0px" },
                },
                [
                  _c("div", { staticClass: "details" }, [
                    _c("dl", { staticClass: "other-details" }, [
                      _c("dt", { staticClass: "total-price" }, [
                        _vm._v(
                          _vm._s(_vm.totalreturnprice[_vm.getCurrentLocale]) +
                            ":"
                        ),
                      ]),
                      _c("dd", { staticClass: "total-price-value" }, [
                        _vm._v(
                          _vm._s(
                            _vm._f("rndAmntRUAFWZ")(
                              _vm.getBookingCartReturnTotal
                            )
                          )
                        ),
                      ]),
                    ]),
                  ]),
                ]
              ),
            ]
          )
        : _vm._e(),
    ],
    2
  )
}
var staticRenderFns = [
  function () {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "table-cell logo" }, [
      _c("img", {
        staticStyle: { "padding-bottom": "3px" },
        attrs: { src: "/res/images/sdr140x30.png", alt: "" },
      }),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }